// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  ClassifyItemRequest,
  ItemTriage,
  itemTriageSchema,
} from '@/items/api/triage-types';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Classifies a triage item by creating the appropriate item type.
 *
 * @param triageKey - The unique key of the triage item
 * @param request - The classification request containing the classification type
 * @returns Promise containing the updated triage item
 */
export async function classifyTriageItem(
  triageKey: string,
  request: ClassifyItemRequest
): Promise<ItemTriage> {
  const url = `/v1/item-triage/${triageKey}/classify`;
  const response = await api.post<ApiResponse>(url, request);

  // Parse and validate the response with Zod
  return parseResponse(itemTriageSchema, response.data.data, {
    schemaName: 'ClassifyTriageItem',
    endpoint: url,
  });
}
